



















import { Vue, Component } from 'vue-property-decorator'
import Table, { Config, Pagination } from '@/views/enroll/components/Table.vue'

import { EnrollConfig, EnrollConfigList } from '@/models/enroll/enrollConfing'
import { getList, getQueryedList, put, del } from '@/api/enroll/enrollConfig'

import { Nilable } from '@/models/helpers/common'
import { notify, comfirm } from '@/utils/notification'
import ConfigEditer from './components/ConfigEditer.vue'

@Component({
  components: { Table,ConfigEditer },
})
export default class EnrollConfigView extends Vue {
  InstantData: EnrollConfig[] = []
  InstantCount = 0
  loading = false
  showEditor = false
  selectedConfig: EnrollConfig = {
    key: '',
    title: '',
    abbr: '',
    description: '',
    disable: true,
    hidden: true,

    startTime: '',
    endTime: '',
    notice: [],
    additional: '',
  }
  get Instantpagination(): Pagination {
    return {
      current: 1,
      pagesize: 10,
    }
  }
  get InstantConfig(): Config {
    return {
      rowKey: 'id',
      total: this.InstantCount,
      selection: 'radio',
      maxHeight: 700,
      columns: [
        // { prop: 'id', label: 'ID', width: 80 },
        { prop: 'key', label: 'Id', width: 200, fixed: 'left' },
        {
          prop: 'title',
          label: '标题',
        },
        {
          prop: 'abbr',
          label: '缩写',
        },
        {
          prop: 'description',
          label: '描述文字',
        },
        {
          prop: 'endTime',
          label: '关闭时间',
        },
        {
          prop: 'disable',
          label: '是否禁止修改/查看',
          formatter: (a:boolean) => {
            if (a == true) {
              return '是'
            } else {
              return '否'
            }
          },
        },
        {
          prop: 'hidden',
          label: '是否隐藏入口',
          formatter: (a:boolean) => {
            if (a == true) {
              return '是'
            } else {
              return '否'
            }
          },
        },
        {
          prop: 'option',
          label: '操作',
          type: {
            type: 'buttonGroup',
            group: [
              {
                event: 'Edit',
                text: '编辑',
                right: '',
                buttonType: 'primary',
              },
              {
                event: 'Delete',
                text: '删除',
                right: '',
                buttonType: 'danger',
              },
            ],
            style: 'group',
            size: 'small',
          },
          width: 200,
          fixed: 'right',
        },
      ],
    }
  }

  backToTable() {
    this.showEditor = false
  }
  saveSuccess() {
    this.showEditor = false
    this.loadData(this.Instantpagination)
  }

  async loadData(pagination: Pagination) {
    try {
      this.loading = true
      let limit = pagination.pagesize
      let offset = pagination.pagesize * (pagination.current - 1)
      const { rows, total } = await getQueryedList(limit, offset)
      this.InstantCount = total
      this.InstantData = rows
    } catch (e) {
      notify('获取数据失败', e)
    }
    this.loading = false
    return this.InstantData
  }
  async onButtonClick($event: any) {
    switch ($event.event) {
      case 'Edit': {
        this.showEditor = true
        this.selectedConfig = $event.row
        return
      }
      case 'Details': {
        return
      }

      case 'Delete': {
        this.selectedConfig = $event.row
        await comfirm(`确认删除${$event.row.title}么?`, { type: 'warning' })
        try {
          await del(this.selectedConfig.id as string)
          notify('删除成功！')
          this.loadData(this.Instantpagination)
        } catch (e) {
          notify('删除失败！', e)
        }
        return
      }
      default:
        break
    }
  }
  async created() {
    this.loadData(this.Instantpagination)
  }
}
